<template>
  <div>
    <div>
      <h1 class="h2 mt-4">Szerződő adatai</h1>
      <fieldset class="form-group row mb-3">
        <legend class="col-sm-4">
          <label
            ><b>A szerződő magánszemély?</b>
            <button
              class="info"
              id="szerzodo-tooltip"
              data-toggle="tooltip"
              data-placement="right"
              title=""
              type="button"
            >
              ?
            </button></label
          >
        </legend>
        <div class="col-sm-8">
          <div class="form-check">
            <input
              type="radio"
              class="form-check-input"
              id="maganszemely-1"
              name="maganszemely"
              :value="1"
              v-model="privatePerson"
            />
            <label for="maganszemely-1" class="form-check-label">Igen</label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              class="form-check-input"
              id="maganszemely-2"
              name="maganszemely"
              :value="0"
              v-model="privatePerson"
            />
            <label for="maganszemely-2" class="form-check-label">Nem</label>
          </div>
        </div>
      </fieldset>

      <!-- jogi személy -->
      <div v-if="!privatePerson">
        <div class="row">
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prependn dark-border">
                <span class="input-group-text" id="szerzodo_vezeteknev-prepend"
                  ><label for="szerzodo_vezeteknev">Név: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control"
                id="szerzodo_vezeteknev"
                name="szerzodo_vezeteknev"
                v-model="contractorLastName"
                aria-label="Vezetéknév"
                aria-describedby="szerzodo_vezeteknev-prepend"
                :class="{ classes, 'dark-border': true }"
              />
            </div>
            <small
              id="szerzodo_vezeteknev-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>

          <ValidationProvider
            rules="required|length:13"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="szerzodo_adoszam-prepend"
                  ><label for="szerzodo_adoszam">Adószám: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                v-mask="'########-#-##'"
                class="form-control"
                id="szerzodo_adoszam"
                name="szerzodo_adoszam"
                v-model="contractorVat"
                aria-label="Adószám"
                aria-describedby="szerzodo_adoszam-prepend"
                :class="{ classes, 'dark-border': true }"
              />
            </div>
            <small
              id="szerzodo_adoszam-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="text-danger fw-normal mb-3">
          Figyelem! A szerződő e-mail címének visszaigazolásának céljából egy 6
          számjegyből álló kódot tartalmazó levelet küldünk az Ön által megadott
          e-mail címre. Kérjük, írja be ezt a számsort a következő oldalon erre
          kijelölt helyen.
          <ul>
            <li>
              Fontos, hogy akkor is adjon meg e-mail címet, ha a
              kapcsolattartáshoz a postai kommunikációt választja.
            </li>
            <li>
              Az e-mail cím megerősítése nélkül a biztosításkötés nem
              lehetséges.
            </li>
          </ul>
          A visszaigazoló kód érvényessége: 30 perc.
        </div>
        <div class="form-group row mb-3">
          <label for="szerzodo_email" class="col-sm-4">
            Szerződő e-mail címe: <span class="text-danger">*</span>
          </label>
          <ValidationProvider
            :rules="{
              required: electronicContact == 1 ? true : false,
              email: true,
            }"
            vid="szerzodo_email"
            v-slot="{ errors, classes }"
            class="col-sm-8"
          >
            <input
              type="email"
              class="form-control"
              id="szerzodo_email"
              name="szerzodo_email"
              v-model="contractorEmail"
              :class="{ classes, 'dark-border': true }"
              :readonly="emailVerified"
            />
            <small id="szerzodo_email-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3">
          <label for="szerzodo_email_2" class="col-sm-4"
            >Szerződő e-mail címének ismételt megadása:
            <span class="text-danger" v-if="contractorEmail != ''"
              >*</span
            ></label
          >
          <ValidationProvider
            :rules="{
              required_if: 'szerzodo_email',
              email: true,
              is: contractorEmail,
            }"
            v-slot="{ errors, classes }"
            class="col-sm-8"
          >
            <input
              type="email"
              class="form-control"
              id="szerzodo_email_2"
              name="szerzodo_email_2"
              v-model="contractorEmailVerification"
              :class="{ classes, 'dark-border': true }"
              :readonly="emailVerified"
            />
            <small
              id="szerzodo_email_2-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="text-danger mb-3">
          Az e-mail cím megerősítése után az e-mail cím módosítása a
          későbbiekben már nem lehetséges.
        </div>

        <div class="form-group row">
          <label class="col-sm-4" for="szerzodo_telefonszam"
            >Szerződő telefonszáma: <span class="text-danger">*</span></label
          >
          <ValidationProvider
            rules="required|max:2"
            v-slot="{ errors, classes }"
            class="col-sm-3 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="szerzodo_telefonszam_korzet_prepend"
                  >+36</span
                >
              </div>
              <input
                type="number"
                min="1"
                max="99"
                class="form-control"
                id="szerzodo_telefonszam_korzet"
                name="szerzodo_telefonszam_korzet"
                aria-label="Körzetszám"
                aria-describedby="szerzodo_telefonszam_korzet_prepend"
                v-model.number="contractorPhoneNumberArea"
                :class="{ classes, 'dark-border': true }"
              />
            </div>
            <small
              id="szerzodo_telefonszam_korzet-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <ValidationProvider
            rules="numeric|required|min:6|max:7"
            v-slot="{ errors, classes }"
            class="col-sm-5"
            :immediate="true"
          >
            <input
              type="number"
              class="form-control"
              id="szerzodo_telefonszam"
              name="szerzodo_telefonszam"
              v-model="contractorPhoneNumber"
              :class="{ classes, 'dark-border': true }"
            />
            <small
              id="szerzodo_telefonszam-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>

        <h2 class="mt-4">Székhely</h2>

        <div class="row">
          <ValidationProvider
            rules="required|zipcode"
            v-slot="{ errors }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="szekhely_irsz-prepend"
                  ><label for="szekhely_irsz">Irányítószám: </label
                  ><span class="text-danger">*</span></span
                >
              </div>

              <div class="flex-grow-1">
                <!-- <Select2
                  id="szekhely_irsz"
                  name="szekhely_irsz"
                  v-model="companyLocationZip"
                  :options="zipCodes"
                  :settings="{selectionCssClass: 'w-full'}"
                /> -->
                <input
                  type="text"
                  id="szekhely_irsz"
                  name="szekhely_irsz"
                  v-model="companyLocationZip"
                  class="form-control dark-border"
                />
              </div>
            </div>
            <small id="szekhely_irsz-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>

          <!-- <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3"> -->
          <div class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="szekhely_telepules-prepend"
                  ><label for="szekhely_telepules">Település neve: </label
                  ><span class="text-danger">*</span></span
                >
              </div>

              <div class="flex-grow-1" v-if="companyCityNames.length > 1">
                <select
                  id="szekhely_telepules"
                  name="szekhely_telepules"
                  v-model="companyLocationCity"
                  class="form-select dark-border"
                >
                  <option
                    v-for="(city, key) in companyCityNames"
                    :key="key"
                    :value="city"
                    >{{ city }}</option
                  >
                </select>
                <!-- <Select2
                  name="szekhely_telepules"
                  v-model="companyLocationCity"
                  :options="companyCityNames"
                  :settings="{selectionCssClass: 'w-full'}"
                /> -->
              </div>

              <input
                v-else
                type="text"
                class="form-control"
                readonly
                :class="{ 'dark-border': true }"
                name="szekhely_telepules"
                :value="companyLocationCity"
              />
            </div>
            <ValidationProvider rules="required" v-slot="{ errors }">
              <input type="text" :value="companyLocationCity" v-show="false" />
              <small class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
            <!-- <small id="szekhely_telepules-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
            </ValidationProvider> -->
          </div>
        </div>
        <div class="row">
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="szekhely_kozterulet-prepend"
                  ><label for="szekhely_kozterulet">Közterület neve: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control"
                id="szekhely_kozterulet"
                name="szekhely_kozterulet"
                v-model="companyLocationName"
                aria-label="Közterület neve"
                aria-describedby="szekhely_kozterulet-prepend"
                :class="{ classes, 'dark-border': true }"
              />
            </div>
            <small
              id="szekhely_kozterulet-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="szekhely_jelleg-prepend"
                  ><label for="szekhely_jelleg">Közterület jellege: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control"
                id="szekhely_jelleg"
                name="szekhely_jelleg"
                v-model="companyLocationType"
                aria-label="Közterület jellege"
                aria-describedby="szekhely_jelleg-prepend"
                :class="{ classes, 'dark-border': true }"
              />
            </div>
            <small id="szekhely_jelleg-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>
        <div class="row">
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="szekhely_hazszam-prepend"
                  ><label for="szekhely_hazszam">Házszám: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control"
                id="szekhely_hazszam"
                name="szekhely_hazszam"
                v-model="companyLocationHouseNumber"
                aria-label="Házszám"
                aria-describedby="szekhely_hazszam-prepend"
                :class="{ classes, 'dark-border': true }"
              />
            </div>
            <small
              id="szekhely_hazszam-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <div class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="szekhely_epl-prepend"
                  ><label for="szekhely_epl">Épület, emelet, ajtó:</label></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="szekhely_epl"
                name="szekhely_epl"
                v-model="companyLocationBuilding"
                aria-label="Épület, emelet, ajtó"
                aria-describedby="szekhely_epl-prepend"
              />
            </div>
            <small
              id="szekhely_epl-error"
              class="text-danger input-alert"
            ></small>
          </div>
        </div>
      </div>

      <!-- magán személy -->
      <div v-else>
        <div class="row">
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="szerzodo_vezeteknev-prepend"
                  ><label for="szerzodo_vezeteknev">Vezetéknév: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control"
                id="szerzodo_vezeteknev"
                name="szerzodo_vezeteknev"
                v-model="contractorLastName"
                aria-label="Vezetéknév"
                aria-describedby="szerzodo_vezeteknev-prepend"
                :class="{ classes, 'dark-border': true }"
              />
            </div>
            <small
              id="szerzodo_vezeteknev-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span class="input-group-text" id="szerzodo_keresztnev-prepend"
                  ><label for="szerzodo_keresztnev">Keresztnév: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control"
                id="szerzodo_keresztnev"
                name="szerzodo_keresztnev"
                v-model="contractorFirstName"
                aria-label="Keresztnév"
                aria-describedby="szerzodo_keresztnev-prepend"
                :class="{ classes, 'dark-border': true }"
              />
            </div>
            <small
              id="szerzodo_keresztnev-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="row">
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="szerzodo_anyja_leanykori_nev-prepend"
                  ><label for="szerzodo_anyja_leanykori_nev"
                    >Anyja leánykori neve: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control"
                id="szerzodo_anyja_leanykori_nev"
                name="szerzodo_anyja_leanykori_nev"
                v-model="contractorMotherChildName"
                aria-label="Anyja leánykori neve"
                aria-describedby="szerzodo_anyja_leanykori_nev-prepend"
                :class="{ classes, 'dark-border': true }"
              />
            </div>
            <small
              id="szerzodo_anyja_leanykori_nev-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <div class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="szerzodo_szuletes_nev-prepend"
                  ><label for="szerzodo_szuletes_nev"
                    >Születéskori neve:</label
                  ></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_szuletes_nev"
                name="szerzodo_szuletes_nev"
                v-model="contractorBornName"
                aria-label="Születéskori neve"
                aria-describedby="szerzodo_szuletes_nev-prepend"
              />
            </div>
            <small
              id="szerzodo_szuletes_nev-error"
              class="text-danger input-alert"
            ></small>
          </div>
        </div>
        <div class="row">
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="szerzodo_szuletesi_hely-prepend"
                  ><label for="szerzodo_szuletesi_hely">Születési hely: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control"
                id="szerzodo_szuletesi_hely"
                name="szerzodo_szuletesi_hely"
                v-model="contractorBornCity"
                aria-label="Születési hely"
                aria-describedby="szerzodo_szuletesi_hely-prepend"
                :class="{ classes, 'dark-border': true }"
              />
            </div>
            <small
              id="szerzodo_szuletesi_hely-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <div class="col-md-6 mb-3">
            <div class="input-group flex-nowrap">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="szerzodo_szuletesi_datum-prepend"
                  ><label for="szerzodo_szuletesi_datum"
                    >Születési dátum: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                id="szerzodo_szuletesi_datum"
                class="form-control dark-border"
                name="szerzodo_szuletesi_datum"
                type="date"
                :min="birthMinDate"
                :max="birthMaxDate"
                v-model="contractorBornDate"
                required
              />
              <!-- <Datepicker
                id="szerzodo_szuletesi_datum_dp4"
                name="szerzodo_szuletesi_datum"
                :format="'yyyy-MM-dd'"
                :placeholder="'Kattintson ide a dátum kiválasztásához'"
                :language="hu"
                :disabled-dates="contractedIsInsured ? biztDisabledDates : bornDisabledDates"
                :typeable="false"
                input-class="form-control dark-border"
                :open-date="bornInitialDate"
                required
                v-model="contractorBornDate"
                aria-label="Születési dátum"
                aria-describedby="szerzodo_szuletesi_datum-prepend"
                class="datepicker-prepend-input dark-border"
              ></Datepicker> -->
            </div>
            <ValidationProvider
              :immediate="true"
              rules="required|szerzodes_szuletes_datum"
              v-slot="{ errors }"
            >
              <input
                type="text"
                name="szerzodo_szuletesi_datum"
                :value="contractorBornDate"
                disabled
                hidden
              />
              <small class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>
        <div class="text-danger fw-normal mb-3">
          Figyelem! A szerződő e-mail címének visszaigazolásának céljából egy 6
          számjegyből álló kódot tartalmazó levelet küldünk az Ön által megadott
          e-mail címre. Kérjük, írja be ezt a számsort a következő oldalon erre
          kijelölt helyen.
          <ul>
            <li>
              Fontos, hogy akkor is adjon meg e-mail címet, ha a
              kapcsolattartáshoz a postai kommunikációt választja.
            </li>
            <li>
              Az e-mail cím megerősítése nélkül a biztosításkötés nem
              lehetséges.
            </li>
          </ul>
          A visszaigazoló kód érvényessége: 30 perc.
        </div>
        <div class="form-group row mb-3">
          <label for="szerzodo_email" class="col-sm-4">
            Szerződő e-mail címe: <span class="text-danger">*</span>
          </label>
          <ValidationProvider
            :rules="{
              required: electronicContact == 1 ? true : false,
              email: true,
            }"
            vid="szerzodo_email"
            v-slot="{ errors, classes }"
            class="col-sm-8"
          >
            <input
              type="email"
              class="form-control"
              id="szerzodo_email"
              name="szerzodo_email"
              v-model="contractorEmail"
              :class="{ classes, 'dark-border': true }"
              :readonly="emailVerified"
            />
            <small id="szerzodo_email-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3">
          <label for="szerzodo_email_2" class="col-sm-4"
            >Szerződő e-mail címének ismételt megadása:
            <span class="text-danger" v-if="contractorEmail != ''"
              >*</span
            ></label
          >
          <ValidationProvider
            :rules="{
              required_if: 'szerzodo_email',
              email: true,
              is: contractorEmail,
            }"
            v-slot="{ errors, classes }"
            class="col-sm-8"
          >
            <input
              type="email"
              class="form-control"
              id="szerzodo_email_2"
              name="szerzodo_email_2"
              v-model="contractorEmailVerification"
              :class="{ classes, 'dark-border': true }"
              :readonly="emailVerified"
            />
            <small
              id="szerzodo_email_2-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="text-danger mb-3">
          Az e-mail cím megerősítése után az e-mail cím módosítása a
          későbbiekben már nem lehetséges.
        </div>
        <div class="form-group row">
          <label class="col-sm-4" for="szerzodo_telefonszam"
            >Szerződő telefonszáma: <span class="text-danger">*</span></label
          >
          <ValidationProvider
            rules="required|max:2"
            v-slot="{ errors, classes }"
            class="col-sm-3 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="szerzodo_telefonszam_korzet_prepend"
                  >+36</span
                >
              </div>
              <input
                type="number"
                min="1"
                max="99"
                class="form-control"
                id="szerzodo_telefonszam_korzet"
                name="szerzodo_telefonszam_korzet"
                aria-label="Körzetszám"
                aria-describedby="szerzodo_telefonszam_korzet_prepend"
                v-model.number="contractorPhoneNumberArea"
                :class="{ classes, 'dark-border': true }"
              />
            </div>
            <small
              id="szerzodo_telefonszam_korzet-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <ValidationProvider
            rules="required|min:6|max:7"
            v-slot="{ errors, classes }"
            class="col-sm-5"
          >
            <input
              type="number"
              class="form-control"
              id="szerzodo_telefonszam"
              name="szerzodo_telefonszam"
              v-model="contractorPhoneNumber"
              :class="{ classes, 'dark-border': true }"
            />
            <small
              id="szerzodo_telefonszam-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
      </div>
    </div>
    <h1 class="h2 mt-4">Kockázatviselés kezdete</h1>
    <div class="form-group row">
      <label class="col-sm-4" for="kockazat_kezdete_dp4"
        >Kockázatviselés kezdete: <span class="text-danger">*</span></label
      >
      <div class="col-sm-8">
        <input
          id="kockazat_kezdete_dp4"
          class="form-control dark-border"
          name="kockazat_kezdete"
          type="date"
          :min="riskStartMinDate"
          :max="riskStartMaxDate"
          v-model="startDate"
          required
        />
        <!-- <Datepicker
          id="kockazat_kezdete_dp4"
          name="kockazat_kezdete"
          :format="'yyyy-MM-dd'"
          :placeholder="'ÉÉÉÉ-HH-NN'"
          :language="hu"
          :disabled-dates="riskStartDisabledDates"
          :typeable="false"
          input-class="form-control"
          required
          v-model="startDate"
        ></Datepicker> -->
        <ValidationProvider
          :immediate="true"
          rules="required|kockazat_kezdet"
          v-slot="{ errors }"
        >
          <input
            type="text"
            name="kockazat_kezdete"
            :value="startDate"
            disabled
            hidden
          />
          <small class="text-danger input-alert">{{ errors[0] }}</small>
        </ValidationProvider>
      </div>
    </div>
    <div>
      <h1 class="h2 mt-4">Kockázatviselés helye</h1>
      <div class="row">
        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <span class="input-group-text" id="kockazat_irsz-prepend"
                ><label for="kockazat_irsz">Irányítószám: </label
                ><span class="text-danger">*</span></span
              >
            </div>
            <input
              type="number"
              class="form-control dark-border"
              id="kockazat_irsz"
              readonly
              :value="propertyZip"
              aria-label="Irányítószám"
              aria-describedby="kockazat_irsz-prepend"
            />
          </div>
        </div>
        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <span class="input-group-text" id="kockazat_telepules-prepend"
                ><label for="kockazat_telepules">Település neve: </label
                ><span class="text-danger">*</span></span
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="kockazat_telepules"
              disabled
              :value="
                typeof propertyName === 'object' && propertyName.length > 0
                  ? selectedPropertyName
                  : propertyName
              "
              aria-label="Település neve"
              aria-describedby="kockazat_telepules-prepend"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <ValidationProvider
          rules="required"
          v-slot="{ errors, classes }"
          class="col-md-6 mb-3"
        >
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <span class="input-group-text" id="kozterulet-prepend"
                ><label for="kozterulet">Közterület neve: </label
                ><span class="text-danger">*</span></span
              >
            </div>
            <input
              type="text"
              class="form-control"
              id="kozterulet"
              name="kozterulet"
              v-model="locationName"
              aria-label="Közterület neve"
              aria-describedby="kozterulet-prepend"
              :class="{ classes, 'dark-border': true }"
            />
          </div>
          <small id="kozterulet-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
        <ValidationProvider
          rules="required"
          v-slot="{ errors, classes }"
          class="col-md-6 mb-3"
        >
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <span class="input-group-text" id="kozterulet_jellege-prepend"
                ><label for="kozterulet_jellege">Közterület jellege: </label
                ><span class="text-danger">*</span></span
              >
            </div>
            <input
              type="text"
              class="form-control"
              id="kozterulet_jellege"
              name="kozterulet_jellege"
              v-model="locationType"
              aria-label="Közterület jellege"
              aria-describedby="kozterulet_jellege-prepend"
              :class="{ classes, 'dark-border': true }"
            />
          </div>
          <small
            id="kozterulet_jellege-error"
            class="text-danger input-alert"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
      </div>
      <div class="row">
        <ValidationProvider
          rules="required"
          v-slot="{ errors, classes }"
          class="col-md-6 mb-3"
        >
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <span class="input-group-text" id="hazszam-prepend"
                ><label for="hazszam">Házszám: </label
                ><span class="text-danger">*</span></span
              >
            </div>
            <input
              type="text"
              class="form-control"
              id="hazszam"
              name="hazszam"
              v-model="locationHouseNumber"
              aria-label="Házszám"
              aria-describedby="hazszam-prepend"
              :class="{ classes, 'dark-border': true }"
            />
          </div>
          <small id="hazszam-error" class="text-danger input-alert">{{
            errors[0]
          }}</small>
        </ValidationProvider>
        <div class="col-md-6 mb-3">
          <div class="input-group">
            <div class="input-group-prepend dark-border">
              <span class="input-group-text" id="kockazat_epl-prepend"
                ><label for="kockazat_epl">Épület, emelet, ajtó:</label></span
              >
            </div>
            <input
              type="text"
              class="form-control dark-border"
              id="kockazat_epl"
              name="kockazat_epl"
              v-model="locationBuilding"
              aria-label="Épület, emelet, ajtó"
              aria-describedby="kockazat_epl-prepend"
            />
          </div>
          <small
            id="kockazat_epl-error"
            class="text-danger input-alert"
          ></small>
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4" for="kockazat_helyrajzi_szam"
          >Helyrajzi szám:
          <button
            class="info"
            id="kockazat_helyrajzi_szam-tooltip"
            data-toggle="tooltip"
            data-placement="right"
            title=""
            type="button"
          >
            ?
          </button></label
        >
        <div class="col-sm-8">
          <input
            class="form-control dark-border"
            type="text"
            id="kockazat_helyrajzi_szam"
            name="kockazat_helyrajzi_szam"
            v-model="locationTopography"
          />
        </div>
      </div>
      <div class="form-group row mb-3">
        <label class="col-sm-4"
          >A szerződő levelezési címe megegyezik a kockázatviselési
          hellyel?</label
        >
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input dark-border"
              type="radio"
              name="szerzodo_levelezes_egyezik"
              id="szerzodo_levelezes_egyezik_igen"
              :value="1"
              v-model="postAddressIsTheSame"
            />
            <label
              class="form-check-label"
              for="szerzodo_levelezes_egyezik_igen"
            >
              Igen
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input dark-border"
              type="radio"
              name="szerzodo_levelezes_egyezik"
              id="szerzodo_levelezes_egyezik_nem"
              :value="0"
              v-model="postAddressIsTheSame"
            />
            <label
              class="form-check-label"
              for="szerzodo_levelezes_egyezik_nem"
            >
              Nem
            </label>
          </div>
        </div>
      </div>
      <div v-if="!postAddressIsTheSame">
        <div class="row">
          <ValidationProvider
            :rules="{
              required: true,
              min: 4,
              max: 4,
              min_value: 1000,
              max_value: 9999,
              zipcode: true,
            }"
            v-slot="{ errors }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="szerzodo_levelezes_irsz-prepend"
                  ><label for="szerzodo_levelezes_irsz">Irányítószám: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="number"
                class="form-control dark-border"
                id="szerzodo_levelezes_irsz"
                name="szerzodo_levelezes_irsz"
                :value="propertyZip"
                aria-label="Irányítószám"
                aria-describedby="szerzodo_levelezes_irsz-prepend"
                v-if="postAddressIsTheSame"
              />

              <div class="flex-grow-1" v-else>
                <!-- <Select2
                  :class="classes"
                  id="szerzodo_levelezes_irsz"
                  name="szerzodo_levelezes_irsz"
                  v-model="contractorLocationZip"
                  :options="zipCodes"
                  :settings="{selectionCssClass: 'w-full'}"
                /> -->
                <input
                  type="text"
                  id="szerzodo_levelezes_irsz"
                  name="szerzodo_levelezes_irsz"
                  v-model="contractorLocationZip"
                  class="form-control dark-border"
                />
              </div>
            </div>
            <small
              id="szerzodo_levelezes_irsz-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <!-- <ValidationProvider rules="required" v-slot="{errors, classes}" class="col-md-6 mb-3"> -->
          <div class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="szerzodo_levelezes_telepules-prepend"
                  ><label for="szerzodo_levelezes_telepules"
                    >Település neve: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_telepules"
                name="szerzodo_levelezes_telepules"
                :value="propertyName"
                aria-label="Település neve"
                aria-describedby="szerzodo_levelezes_telepules-prepend"
                v-if="postAddressIsTheSame"
              />

              <template v-else>
                <div class="flex-grow-1" v-if="mailingCityNames.length > 1">
                  <select
                    id="szerzodo_levelezes_telepules"
                    name="szerzodo_levelezes_telepules"
                    v-model="contractorSelectedLocationName"
                    class="form-select dark-border"
                  >
                    <option
                      v-for="(city, key) in mailingCityNames"
                      :key="key"
                      :value="city"
                      >{{ city }}</option
                    >
                  </select>
                  <!-- <Select2
                    name="szerzodo_levelezes_telepules"
                    v-model="contractorSelectedLocationName"
                    :options="mailingCityNames"
                    :settings="{selectionCssClass: 'w-full'}"
                  /> -->
                </div>

                <input
                  v-else
                  id="szerzodo_levelezes_telepules"
                  type="text"
                  class="form-control dark-border"
                  readonly
                  name="szerzodo_levelezes_telepules"
                  :value="contractorSelectedLocationName"
                />
              </template>
            </div>

            <!-- <small id="szerzodo_levelezes_telepules-error" class="text-danger input-alert">{{
              errors[0]
            }}</small>
          </ValidationProvider> -->
            <ValidationProvider rules="required" v-slot="{ errors }">
              <input
                type="text"
                :value="contractorSelectedLocationName"
                v-show="false"
              />
              <small class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>
        <div class="row">
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="szerzodo_levelezes_kozterulet-prepend"
                  ><label for="szerzodo_levelezes_kozterulet"
                    >Közterület neve: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_kozterulet"
                name="szerzodo_levelezes_kozterulet"
                :value="locationName"
                aria-label="Közterület neve"
                aria-describedby="szerzodo_levelezes_kozterulet-prepend"
                :class="classes"
                v-if="postAddressIsTheSame"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_kozterulet"
                name="szerzodo_levelezes_kozterulet"
                v-model="contractorLocationName"
                aria-label="Közterület neve"
                aria-describedby="szerzodo_levelezes_kozterulet-prepend"
                :class="classes"
                v-else
              />
            </div>
            <small
              id="szerzodo_levelezes_kozterulet-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="szerzodo_levelezes_jelleg-prepend"
                  ><label for="szerzodo_levelezes_jelleg"
                    >Közterület jellege: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_jelleg"
                name="szerzodo_levelezes_jelleg"
                :value="locationType"
                aria-label="Közterület jellege"
                aria-describedby="szerzodo_levelezes_jelleg-prepend"
                :class="classes"
                v-if="postAddressIsTheSame"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_jelleg"
                name="szerzodo_levelezes_jelleg"
                v-model="contractorLocationType"
                aria-label="Közterület jellege"
                aria-describedby="szerzodo_levelezes_jelleg-prepend"
                :class="classes"
                v-else
              />
            </div>
            <small
              id="szerzodo_levelezes_jelleg-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="row">
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="szerzodo_levelezes_hazszam-prepend"
                  ><label for="szerzodo_levelezes_hazszam">Házszám: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_hazszam"
                name="szerzodo_levelezes_hazszam"
                :value="locationHouseNumber"
                aria-label="Házszám"
                aria-describedby="szerzodo_levelezes_hazszam-prepend"
                :class="classes"
                v-if="postAddressIsTheSame"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_hazszam"
                name="szerzodo_levelezes_hazszam"
                v-model="contractorLocationHouseNumber"
                aria-label="Házszám"
                aria-describedby="szerzodo_levelezes_hazszam-prepend"
                :class="classes"
                v-else
              />
            </div>
            <small
              id="szerzodo_levelezes_hazszam-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <div class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="szerzodo_levelezes_epl-prepend"
                  ><label for="szerzodo_levelezes_epl"
                    >Épület, emelet, ajtó:</label
                  ></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_epl"
                name="szerzodo_levelezes_epl"
                :value="locationBuilding"
                aria-label="Épület, emelet, ajtó"
                aria-describedby="szerzodo_levelezes_epl-prepend"
                v-if="postAddressIsTheSame"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="szerzodo_levelezes_epl"
                name="szerzodo_levelezes_epl"
                v-model="contractorLocationBuilding"
                aria-label="Épület, emelet, ajtó"
                aria-describedby="szerzodo_levelezes_epl-prepend"
                v-else
              />
            </div>
            <small
              id="szerzodo_levelezes_epl-error"
              class="text-danger input-alert"
            ></small>
          </div>
        </div>
      </div>
    </div>
    <div>
      <h1 class="h2 mt-4">Biztosított adatai</h1>
      <div class="form-group row mb-3" v-show="privatePerson">
        <label class="col-sm-4"
          >A szerződő személye megegyezik a biztosított ingatlan/ingóság
          tulajdonosával/bérlőjével?</label
        >
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="szerzodo_biztositott"
              id="szerzodo_biztositott_igen"
              :value="1"
              v-model="contractedIsInsured"
            />
            <label class="form-check-label" for="szerzodo_biztositott_igen">
              Igen
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="szerzodo_biztositott"
              id="szerzodo_biztositott_nem"
              :value="0"
              v-model="contractedIsInsured"
            />
            <label class="form-check-label" for="szerzodo_biztositott_nem">
              Nem
            </label>
          </div>
        </div>
      </div>
      <div v-show="!contractedIsInsured || !privatePerson">
        <!-- <span v-if="kegyeletiSelected" class="text-danger fw-normal"
          >Biztosított olyan természetes személy lehet, aki a jelen kiegészítő biztosításra
          vonatkozó írásbeli ajánlattétel napján nem töltötte be a 65. életévét.</span
        >
        <span v-if="balesetiSelected" class="text-danger fw-normal"
          >Biztosított olyan természetes személy lehet, aki a jelen kiegészítő biztosításra
          vonatkozó írásbeli ajánlattétel napján nem töltötte be a 70. életévét.</span
        > -->
        <div class="row">
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="biztositott_vezeteknev_prepend"
                  ><label for="biztositott_vezeteknev">Vezetéknév: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control"
                id="biztositott_vezeteknev"
                name="biztositott_vezeteknev"
                :value="contractorLastName"
                aria-label="Vezetéknév"
                aria-describedby="biztositott_vezeteknev_prepend"
                :class="{ classes, 'dark-border': true }"
                v-if="contractedIsInsured && privatePerson"
              />
              <input
                type="text"
                class="form-control"
                id="biztositott_vezeteknev"
                name="biztositott_vezeteknev"
                v-model="insuredLastName"
                aria-label="Vezetéknév"
                aria-describedby="biztositott_vezeteknev_prepend"
                :class="{ classes, 'dark-border': true }"
                v-else
              />
            </div>
            <small
              id="biztositott_vezeteknev-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="biztositott_keresztnev_prepend"
                  ><label for="biztositott_keresztnev">Keresztnév: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_keresztnev"
                name="biztositott_keresztnev"
                :value="contractorFirstName"
                aria-label="Keresztnév"
                aria-describedby="biztositott_keresztnev_prepend"
                :class="{ classes, 'dark-border': true }"
                v-if="contractedIsInsured && privatePerson"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_keresztnev"
                name="biztositott_keresztnev"
                v-model="insuredFirstName"
                aria-label="Keresztnév"
                aria-describedby="biztositott_keresztnev_prepend"
                :class="{ classes, 'dark-border': true }"
                v-else
              />
            </div>
            <small
              id="biztositott_keresztnev-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="row">
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="biztositott_anyja_leanykori_nev_prepend"
                  ><label for="biztositott_anyja_leanykori_nev"
                    >Anyja leánykori neve: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_anyja_leanykori_nev"
                name="biztositott_anyja_leanykori_nev"
                :value="contractorMotherChildName"
                aria-label="Anyja leánykori neve"
                aria-describedby="biztositott_anyja_leanykori_nev_prepend"
                :class="{ classes, 'dark-border': true }"
                v-if="contractedIsInsured && privatePerson"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_anyja_leanykori_nev"
                name="biztositott_anyja_leanykori_nev"
                v-model="insuredMotherChildName"
                aria-label="Anyja leánykori neve"
                aria-describedby="biztositott_anyja_leanykori_nev_prepend"
                :class="{ classes, 'dark-border': true }"
                v-else
              />
            </div>
            <small
              id="biztositott_anyja_leanykori_nev-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <div class="col-md-6 mb-3">
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="biztositott_szuletes_nev_prepend"
                  ><label for="biztositott_szuletes_nev"
                    >Születéskori neve:</label
                  ></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_szuletes_nev"
                name="biztositott_szuletes_nev"
                :value="contractorBornName"
                aria-label="Keresztnév"
                aria-describedby="biztositott_szuletes_nev_prepend"
                v-if="contractedIsInsured && privatePerson"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_szuletes_nev"
                name="biztositott_szuletes_nev"
                v-model="insuredBornName"
                aria-label="Keresztnév"
                aria-describedby="biztositott_szuletes_nev_prepend"
                v-else
              />
            </div>
            <small
              id="biztositott_szuletes_nev-error"
              class="text-danger input-alert"
            ></small>
          </div>
        </div>
        <div class="row">
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-md-6 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="biztositott_szuletesi_hely-prepend"
                  ><label for="biztositott_szuletesi_hely"
                    >Születési hely: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_szuletesi_hely"
                name="biztositott_szuletesi_hely"
                :value="contractorBornCity"
                aria-label="Születési hely"
                aria-describedby="biztositott_szuletesi_hely-prepend"
                :class="classes"
                v-if="contractedIsInsured && privatePerson"
              />
              <input
                type="text"
                class="form-control dark-border"
                id="biztositott_szuletesi_hely"
                name="biztositott_szuletesi_hely"
                v-model="insuredBornCity"
                aria-label="Születési hely"
                aria-describedby="biztositott_szuletesi_hely-prepend"
                :class="classes"
                v-else
              />
            </div>
            <small
              id="biztositott_szuletesi_hely-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <div class="col-md-6 mb-3">
            <div class="input-group flex-nowrap">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="biztositott_szuletett-prepend"
                  ><label for="biztositott_szuletett">Születési dátum: </label
                  ><span class="text-danger">*</span></span
                >
              </div>
              <input
                v-if="contractedIsInsured && privatePerson"
                id="biztositott_szuletett"
                name="biztositott_szuletett"
                class="form-control dark-border"
                type="date"
                :min="birthMinDate"
                :max="birthMaxDate"
                v-model="contractorBornDate"
                required
              />
              <input
                v-else
                id="biztositott_szuletett"
                name="biztositott_szuletett"
                class="form-control dark-border"
                type="date"
                :min="birthMinDate"
                :max="birthMaxDate"
                v-model="insuredBornDate"
                required
              />
              <!-- <Datepicker
                id="biztositott_szuletett"
                name="biztositott_szuletett"
                :format="'yyyy-MM-dd'"
                :placeholder="'Kattintson ide a dátum kiválasztásához'"
                :language="hu"
                :disabled-dates="biztDisabledDates"
                :typeable="false"
                input-class="form-control"
                :open-date="new Date()"
                required
                :value="contractorBornDate"
                aria-label="Születési dátum"
                aria-describedby="biztositott_szuletett-prepend"
                class="datepicker-prepend-input"
                v-if="contractedIsInsured && privatePerson"
              ></Datepicker> -->
              <!-- <Datepicker
                id="biztositott_szuletett"
                name="biztositott_szuletett"
                :format="'yyyy-MM-dd'"
                :placeholder="'Kattintson ide a dátum kiválasztásához'"
                :language="hu"
                :disabled-dates="biztDisabledDates"
                :typeable="false"
                input-class="form-control"
                :open-date="new Date()"
                required
                v-model="insuredBornDate"
                aria-label="Születési dátum"
                aria-describedby="biztositott_szuletett-prepend"
                class="datepicker-prepend-input"
                v-else
              ></Datepicker> -->
            </div>
            <ValidationProvider
              :immediate="true"
              rules="required|szerzodes_szuletes_datum"
              v-slot="{ errors }"
              v-if="!contractedIsInsured"
            >
              <input
                type="text"
                name="biztositott_szuletett"
                :value="insuredBornDate"
                disabled
                hidden
              />
              <small class="text-danger input-alert">{{ errors[0] }}</small>
            </ValidationProvider>
          </div>
        </div>
        <div class="form-group row mb-3">
          <label for="biztositott_email" class="col-sm-4"
            >E-mail cím: <span class="text-danger">*</span></label
          >
          <ValidationProvider
            :rules="{
              required: electronicContact == 1 ? true : false,
              email: true,
            }"
            v-slot="{ errors, classes }"
            class="col-sm-8"
          >
            <input
              type="email"
              class="form-control dark-border"
              id="biztositott_email"
              name="biztositott_email"
              :value="contractorEmail"
              :class="classes"
              v-if="contractedIsInsured && privatePerson"
            />
            <input
              type="email"
              class="form-control dark-border"
              id="biztositott_email"
              name="biztositott_email"
              v-model="insuredEmail"
              :class="classes"
              v-else
            />
            <small
              id="biztositott_email-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="form-group row">
          <label class="col-sm-4" for="biztositott_telefonszam"
            >Biztosított telefonszáma: <span class="text-danger">*</span></label
          >
          <ValidationProvider
            rules="required|max:2"
            v-slot="{ errors, classes }"
            class="col-sm-3 mb-3"
          >
            <div class="input-group">
              <div class="input-group-prepend dark-border">
                <span
                  class="input-group-text"
                  id="biztositott_telefonszam_korzet_prepend"
                  >+36</span
                >
              </div>
              <input
                type="number"
                min="1"
                max="99"
                class="form-control dark-border"
                id="biztositott_telefonszam_korzet"
                name="biztositott_telefonszam_korzet"
                aria-label="Körzetszám"
                aria-describedby="biztositott_telefonszam_korzet_prepend"
                :value="contractorPhoneNumberArea"
                :class="classes"
                v-if="contractedIsInsured && privatePerson"
              />
              <input
                type="number"
                min="1"
                max="99"
                class="form-control dark-border"
                id="biztositott_telefonszam_korzet"
                name="biztositott_telefonszam_korzet"
                aria-label="Körzetszám"
                aria-describedby="biztositott_telefonszam_korzet_prepend"
                v-model.number="insuredPhoneNumberArea"
                :class="classes"
                v-else
              />
            </div>
            <small
              id="biztositott_telefonszam_korzet-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <ValidationProvider
            rules="required|min:6|max:7"
            v-slot="{ errors, classes }"
            class="col-sm-5"
          >
            <input
              type="number"
              class="form-control dark-border"
              id="biztositott_telefonszam"
              name="biztositott_telefonszam"
              :value="contractorPhoneNumber"
              :class="classes"
              v-if="contractedIsInsured && privatePerson"
            />
            <input
              type="number"
              class="form-control dark-border"
              id="biztositott_telefonszam"
              name="biztositott_telefonszam"
              v-model="insuredPhoneNumber"
              :class="classes"
              v-else
            />
            <small
              id="biztositott_telefonszam-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
      </div>
    </div>
    <div v-if="contractFor !== 3">
      <h1 class="h2 mt-4">
        Jelzálog
        <button
          class="info"
          id="jelzalog-tooltip"
          data-toggle="tooltip"
          data-placement="right"
          title=""
          type="button"
        >
          ?
        </button>
      </h1>
      <div class="form-group row mb-3">
        <label class="col-sm-4">Az ingatlan jelzáloggal terhelt?</label>
        <div class="col-sm-8">
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ingatlan_jelzalog"
              id="ingatlan_jelzalog_igen"
              :value="1"
              v-model="propertyIsMortgaged"
            />
            <label class="form-check-label" for="ingatlan_jelzalog_igen">
              Igen
            </label>
          </div>
          <div class="form-check">
            <input
              class="form-check-input"
              type="radio"
              name="ingatlan_jelzalog"
              id="ingatlan_jelzalog_nem"
              :value="0"
              v-model="propertyIsMortgaged"
            />
            <label class="form-check-label" for="ingatlan_jelzalog_nem">
              Nem
            </label>
          </div>
        </div>
      </div>
      <div v-if="propertyIsMortgaged">
        <div
          class="form-group row mb-3"
          v-if="this.$store.state.generalInfo.rebuild_building === 1"
        >
          <label class="col-sm-4" for="jelzalog_hitel_osszeg_alap"
            >Épületbiztosítás elvárt biztosítási összege:
            <span class="text-danger">*</span></label
          >
          <ValidationProvider
            rules="required|min_value:1"
            v-slot="{ errors, classes }"
            class="col-sm-8"
            name="mező"
          >
            <input
              type="text"
              class="form-control dark-border"
              id="jelzalog_hitel_ujaepites_ertek"
              name="jelzalog_hitel_ujaepites_ertek"
              :class="classes"
              v-model="mortgageRebuildValue"
            />
            <div
              class="alert-warning"
              v-if="mortgageRebuildValue > recommendedInsurancePrice * 1.5"
            >
              Kérjük, ellenőrizze a biztosítási összeg értékét.
            </div>
            <small
              id="jelzalog_hitel_ujaepites_ertek-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="jelzalog_hitelezo_azon_alap"
            >Hitelező cég neve: <span class="text-danger">*</span></label
          >
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            name="mező"
            class="col-sm-4"
          >
            <select
              class="form-select dark-border"
              name="jelzalog_hitelezo_azon"
              id="jelzalog_hitelezo_azon_alap"
              :class="classes"
              v-model="mortgageBank"
            >
              <option :value="null">Kérem válasszon</option>
              <option :value="'0000000000'">Manuálisan megadom</option>
              <option :value="bank.id" v-for="(bank, key) in banks" :key="key">
                {{ bank.name }}
              </option>
            </select>
            <small
              id="jelzalog_hitelezo_azon-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-sm-4"
          >
            <input
              aria-label="Alap jelzálog hitelező név"
              type="text"
              class="form-control dark-border"
              id="jelzalog_hitelezo_nev_alap"
              name="jelzalog_hitelezo_nev"
              v-model="mortgageCreditor"
              :class="classes"
              :readonly="mortgageBank != '0000000000'"
            />
            <small
              id="jelzalog_hitelezo_nev-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="jelzalog_hitelezo_szekhely_alap"
            >Hitelező cég székhelye:<span class="text-danger">*</span></label
          >
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            name="mező"
            class="col-sm-8"
          >
            <div class="col-sm-8">
              <input
                type="text"
                class="form-control dark-border"
                id="jelzalog_hitelezo_szekhely_alap"
                name="jelzalog_hitelezo_szekhely"
                v-model="mortgageCreditorLocation"
              />
            </div>
            <small
              id="jelzalog_hitelezo_szekhely-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3" v-if="!this.$store.state.dm">
          <label class="col-sm-4" for="jelzalog_hitel_tipusa"
            >Hitelszerződés típusa: <span class="text-danger">*</span></label
          >
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            name="mező"
            class="col-sm-8"
          >
            <select
              class="form-select dark-border"
              name="jelzalog_hitel_tipusa"
              id="jelzalog_hitel_tipusa"
              :class="classes"
              v-model="mortgageType"
            >
              <option :value="null">Kérem válasszon</option>

              <option
                v-for="(label, id) in mortgagetypes"
                :key="id"
                :value="id"
              >
                {{ label }}
              </option>
            </select>
            <small
              id="jelzalog_hitel_tipusa-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3" v-if="this.$store.state.dm">
          <label class="col-sm-4" for="jelzalog_azonosito"
            >Hitelszerződés azonosítója:</label
          >
          <ValidationProvider v-slot="{ errors, classes }" class="col-sm-8">
            <input
              type="text"
              class="form-control dark-border"
              id="jelzalog_azonosito_alap"
              name="jelzalog_azonosito"
              :class="classes"
              v-model="mortgageId"
            />
            <small
              id="jelzalog_azonosito-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3" v-else>
          <label class="col-sm-4" for="jelzalog_azonosito_alap"
            >Hitelszerződés azonosítója:
            <span class="text-danger">*</span></label
          >
          <ValidationProvider
            rules="required"
            v-slot="{ errors, classes }"
            class="col-sm-8"
          >
            <input
              type="text"
              class="form-control dark-border"
              id="jelzalog_azonosito_alap"
              name="jelzalog_azonosito"
              :class="classes"
              v-model="mortgageId"
            />
            <small
              id="jelzalog_azonosito-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
        </div>
        <div class="form-group row mb-3" v-if="this.$store.state.dm">
          <label class="col-sm-4" for="jelzalog_hitel_osszeg_alap"
            >Hitel összege és devizaneme:</label
          >
          <ValidationProvider v-slot="{ errors, classes }" class="col-sm-6">
            <input
              type="text"
              class="form-control dark-border"
              id="jelzalog_hitel_osszeg_alap"
              name="jelzalog_hitel_osszeg"
              :class="classes"
              v-model="mortgagePrice"
            />
            <small
              id="jelzalog_hitel_osszeg-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <div class="col-sm-2">
            <select
              aria-label="Alap jelzálog hitel deviza"
              name="jelzalog_hitel_deviza"
              id="jelzalog_hitel_deviza_alap"
              class="form-select dark-border"
              v-model="mortgageCurrency"
            >
              <option :value="null">Nincs kiválasztva</option>
              <option value="AUD">AUD</option>
              <option value="CAD">CAD</option>
              <option value="CHF">CHF</option>
              <option value="CZK">CZK</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
              <option value="HRK">HRK</option>
              <option value="HUF">HUF</option>
              <option value="PLN">PLN</option>
              <option value="RON">RON</option>
              <option value="SEK">SEK</option>
              <option value="TRY">TRY</option>
              <option value="USD">USD</option>
            </select>
          </div>
        </div>
        <div class="form-group row mb-3" v-else>
          <label class="col-sm-4" for="jelzalog_hitel_osszeg_alap"
            >Hitel összege és devizaneme:
            <span class="text-danger">*</span></label
          >
          <ValidationProvider
            rules="required|min_value:1"
            v-slot="{ errors, classes }"
            class="col-sm-6"
          >
            <input
              type="text"
              class="form-control dark-border"
              id="jelzalog_hitel_osszeg_alap"
              name="jelzalog_hitel_osszeg"
              :class="classes"
              v-model="mortgagePrice"
            />
            <small
              id="jelzalog_hitel_osszeg-error"
              class="text-danger input-alert"
              >{{ errors[0] }}</small
            >
          </ValidationProvider>
          <div class="col-sm-2">
            <select
              aria-label="Alap jelzálog hitel deviza"
              name="jelzalog_hitel_deviza"
              id="jelzalog_hitel_deviza"
              class="form-select dark-border"
              v-model="mortgageCurrency"
            >
              <option :value="null">Nincs kiválasztva</option>
              <option value="AUD">AUD</option>
              <option value="CAD">CAD</option>
              <option value="CHF">CHF</option>
              <option value="CZK">CZK</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
              <option value="HRK">HRK</option>
              <option value="HUF">HUF</option>
              <option value="PLN">PLN</option>
              <option value="RON">RON</option>
              <option value="SEK">SEK</option>
              <option value="TRY">TRY</option>
              <option value="USD">USD</option>
            </select>
          </div>
        </div>
        <div class="form-group row mb-3">
          <label class="col-sm-4" for="jelzalog_hitel_kezdete_alap"
            >Hitel kezdete:</label
          >
          <div class="col-sm-8">
            <input
              id="jelzalog_hitel_kezdete_alap"
              name="jelzalog_hitel_kezdete"
              class="form-control dark-border"
              min="1900-01-01"
              max="9999-12-31"
              type="date"
              v-model="mortgageStartDate"
              required
            />
            <!-- <Datepicker
              id="jelzalog_hitel_kezdete"
              name="jelzalog_hitel_kezdete"
              :format="'yyyy-MM-dd'"
              :placeholder="'ÉÉÉÉ-HH-NN'"
              :language="hu"
              :typeable="true"
              input-class="form-control"
              v-model="mortgageStartDate"
            ></Datepicker> -->
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4" for="jelzalog_hitel_lejarat_alap"
            >Hitel lejárata:</label
          >
          <div class="col-sm-8">
            <input
              id="jelzalog_hitel_lejarat_alap"
              name="jelzalog_hitel_lejarat"
              class="form-control dark-border"
              type="date"
              min="1900-01-01"
              max="9999-12-31"
              v-model="mortgageEndDate"
              required
            />
            <!-- <Datepicker
              id="jelzalog_hitel_lejarat"
              name="jelzalog_hitel_lejarat"
              :format="'yyyy-MM-dd'"
              :placeholder="'ÉÉÉÉ-HH-NN'"
              :language="hu"
              :typeable="true"
              input-class="form-control"
              v-bind:value="mortgageEndDate"
            ></Datepicker> -->
          </div>
        </div>
        <div v-for="(mortgage, key) in mortgageList" :key="key + 2">
          <h2 v-if="mortgageList.length > 0" class="mt-5">
            {{ key + 2 }}. jelzálog adatai
          </h2>
          <Mortgage :mortgage="mortgage" :pKey="key" listName="mortgage" />
        </div>
        <div class="col-sm-4 col-md-2">
          <button
            type="button"
            class="add-new-item btn btn-outline-danger w-100"
            @click="addMortgage(mortgageList, 'mortgage')"
          >
            További jelzálog hozzáadása
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { mapFields } from "vuex-map-fields";
import { hu } from "vuejs-datepicker/dist/locale";
import Select2 from "v-select2-component";
import Mortgage from "./components/Mortgage.vue";
import moment from "moment";

export default {
  components: {
    Datepicker,
    Select2,
    Mortgage,
  },
  data() {
    const now = new Date();
    const today = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() - 1
    );
    const minDate = new Date();
    minDate.setFullYear(1900);
    minDate.setMonth(1);
    minDate.setDate(1);
    const maxDate = new Date();
    maxDate.setFullYear(today.getFullYear() - 18);
    maxDate.setMonth(now.getMonth());
    maxDate.setDate(now.getDate());
    const birthMinDate = moment(minDate).format("YYYY-MM-DD");
    const birthMaxDate = moment(maxDate).format("YYYY-MM-DD");
    const riskStartMinDate = moment(
      new Date(new Date().setDate(now.getDate() + 1))
    ).format("YYYY-MM-DD");
    const riskStartMaxDate = moment(
      new Date(new Date().setDate(now.getDate() + 180))
    ).format("YYYY-MM-DD");

    return {
      hu: hu,
      yearlyDefaultPrice: 0,
      accessorySumPrice: 0,
      discountPrice: 0,
      frequencyPrice: 0,
      // mortgageBank: null,
      bornInitialDate: maxDate,
      companyCityNames: [],
      mailingCityNames: [],
      riskStartDisabledDates: {
        customPredictor: function(date) {
          const maxDate = new Date().setDate(now.getDate() + 180);
          return date < now || date > maxDate;
        },
      },
      birthMinDate,
      birthMaxDate,
      riskStartMinDate,
      riskStartMaxDate,
      bornDisabledDates: {
        customPredictor: function(date) {
          return date > maxDate || date < minDate;
        },
      },
      biztDisabledDates: {
        customPredictor: function(date) {
          return date > today || date < minDate;
        },
      },
    };
  },
  computed: {
    ...mapFields([
      "cities",
      "merchant_id",
      "contractorPropertyZipChanged",
      "insuranceProperty.recommendedInsurancePrice",
      "generalInfo.privatePerson",
      "generalInfo.contractorVat",
      "generalInfo.contractFor",
      "riskSettings.startDate",
      "generalInfo.propertyZip",
      "generalInfo.propertyName",
      "generalInfo.selectedPropertyName",
      "riskSettings.locationName",
      "riskSettings.locationType",
      "riskSettings.locationHouseNumber",
      "riskSettings.locationBuilding",
      "riskSettings.locationTopography",
      "generalInfo.rebuild_building",
      "riskSettings.companyLocationZip",
      "riskSettings.companyLocationCity",
      "riskSettings.companyLocationName",
      "riskSettings.companyLocationType",
      "riskSettings.companyLocationHouseNumber",
      "riskSettings.companyLocationBuilding",

      "electronicContact",

      "contractSettings.emailVerified",
      "contractSettings.postAddressIsTheSame",
      "insuredSettings.contractedIsInsured",
      "mortgageSettings.propertyIsMortgaged",

      "statementSettings.privacyStatement",
      "statementSettings.insuranceTerms",
      "statementSettings.electronicCommunation",
      "statementSettings.marketingMails",

      "banks",
      "mortgagetypes",
    ]),
    ...mapFields({
      contractorLastName: "contractSettings.lastName",
      contractorFirstName: "contractSettings.firstName",
      contractorMotherChildName: "contractSettings.motherChildName",
      contractorBornName: "contractSettings.bornName",
      contractorBornCity: "contractSettings.bornCity",
      contractorBornDate: "contractSettings.bornDate",
      contractorPhoneNumberArea: "contractSettings.phoneNumberArea",
      contractorPhoneNumber: "contractSettings.phoneNumber",
      contractorEmail: "contractSettings.email",
      contractorEmailVerification: "contractSettings.emailVerification",

      contractorLocationZip: "contractSettings.postAddress.locationZip",
      contractorLocationCity: "contractSettings.postAddress.locationCity",
      contractorLocationName: "contractSettings.postAddress.locationName",
      contractorSelectedLocationName:
        "contractSettings.postAddress.selectedLocationName",
      contractorLocationType: "contractSettings.postAddress.locationType",
      contractorLocationHouseNumber:
        "contractSettings.postAddress.locationHouseNumber",
      contractorLocationBuilding:
        "contractSettings.postAddress.locationBuilding",
      contractorLocationTopography:
        "contractSettings.postAddress.locationTopography",

      insuredLastName: "insuredSettings.lastName",
      insuredFirstName: "insuredSettings.firstName",
      insuredMotherChildName: "insuredSettings.motherChildName",
      insuredBornName: "insuredSettings.bornName",
      insuredBornCity: "insuredSettings.bornCity",
      insuredBornDate: "insuredSettings.bornDate",
      insuredPhoneNumberArea: "insuredSettings.phoneNumberArea",
      insuredPhoneNumber: "insuredSettings.phoneNumber",
      insuredEmail: "insuredSettings.email",
      insuredEmailVerification: "insuredSettings.emailVerification",

      mortgageBank: "mortgageSettings.mortgageBank",
      mortgageCreditor: "mortgageSettings.creditor",
      mortgageCreditorLocation: "mortgageSettings.creditorLocation",
      mortgageId: "mortgageSettings.mortgageId",
      mortgageType: "mortgageSettings.mortgageType",
      mortgagePrice: "mortgageSettings.mortgagePrice",
      mortgageRebuildValue: "mortgageSettings.rebuildValue",
      mortgageCurrency: "mortgageSettings.mortgageCurrency",
      mortgageStartDate: "mortgageSettings.mortgageStartDate",
      mortgageEndDate: "mortgageSettings.mortgageEndDate",
      kegyeletiSelected:
        "chooseableAccesories.selectableList.kegyeleti.selected",
      balesetiSelected: "chooseableAccesories.selectableList.baleset.selected",

      mortgageTemplae: "chooseableAccesories.mortgage.template",
      mortgageList: "chooseableAccesories.mortgage.list",

      paymentType: "paymentOptions.type",
    }),
    zipCodes: {
      get() {
        return Object.keys(this.cities);
      },
    },
    // formattedBornDate() {
    //   console.log("insured now: " + this.insuredBornDate);
    //   console.log("insured now: " + this.contractorBornDate);
    //   if (!this.insuredBornDate && !this.contractorBornDate) return;

    //   if (this.contractedIsInsured && this.privatePerson) {
    //     return new Date(new Date(this.contractorBornDate).getFullYear(), new Date(this.contractorBornDate).getMonth(), new Date(this.contractorBornDate).getDate()+1).toISOString().split("T")[0]
    //   } else {
    //     if (this.insuredBornDate) {
    //       return new Date(new Date(this.insuredBornDate).getFullYear(), new Date(this.insuredBornDate).getMonth(), new Date(this.insuredBornDate).getDate()+1).toISOString().split("T")[0]
    //     }
    //   }
    // }
  },
  methods: {
    getCityNamesByZip: function(zip) {
      const zipCodeList = Object.keys(this.cities);
      if (
        zipCodeList.length === 0 ||
        (zipCodeList.length > 0 && !zipCodeList.includes(zip))
      )
        return [];

      const zipData = this.cities[zip];

      if (!zipData) return [];

      return typeof zipData.telepules === "string"
        ? [zipData.telepules]
        : Object.values(zipData.telepules);
    },
    addMortgage(insuredPersons, listName) {
      if (insuredPersons.length < 10)
        this.$store.commit("addMortgage", {
          listName: listName,
          person: Object.assign({}, this.mortgageTemplae),
        });
    },
  },
  watch: {
    contractorPhoneNumberArea: function(newVal) {
      if (newVal > 99) this.contractorPhoneNumberArea = 99;
      if (newVal < 0) this.contractorPhoneNumberArea = 1;
    },
    insuredPhoneNumberArea: function(newVal) {
      if (newVal > 99) this.insuredPhoneNumberArea = 99;
      if (newVal < 0) this.insuredPhoneNumberArea = 1;
    },
    mortgageBank: function(newVal, oldVal) {
      const bank = this.banks.find((bank) => bank.id === newVal);
      if (bank) {
        this.mortgageCreditor = bank.name;
        if (bank.address) {
          this.mortgageCreditorLocation = bank.address.replaceAll(",", "");
        } else {
          this.mortgageCreditorLocation = bank.address;
        }
      } else {
        if (newVal == "0000000000") {
          //
        } else {
          this.mortgageBank = null;
        }
        this.mortgageCreditor = "";
        this.mortgageCreditorLocation = "";
      }
    },
    mortgageCreditorLocation: function(newVal) {
      if (newVal) {
        this.mortgageCreditorLocation = newVal.replaceAll(",", "");
      } else {
        this.mortgageCreditorLocation = newVal;
      }
    },
    companyLocationZip: function(newVal) {
      this.companyCityNames = this.getCityNamesByZip(newVal);

      if (
        this.zipCodes.length === 0 ||
        (this.zipCodes.length > 0 &&
          !this.zipCodes.includes(this.companyLocationZip))
      )
        return (this.cityNames = []);

      this.companyLocationCity = null;

      const zipData = this.cities[this.companyLocationZip];
      if (!zipData) return (this.cityNames = []);

      this.companyCityNames =
        typeof zipData.telepules === "string"
          ? [zipData.telepules]
          : Object.values(zipData.telepules);

      if (this.companyCityNames.length === 1) {
        this.companyLocationCity = this.companyCityNames[0];
      }
    },
    contractorLocationZip: function(newVal) {
      this.mailingCityNames = this.getCityNamesByZip(newVal);

      if (
        this.zipCodes.length === 0 ||
        (this.zipCodes.length > 0 &&
          !this.zipCodes.includes(this.contractorLocationZip))
      )
        return (this.cityNames = []);

      this.mailingCityNames = null;

      const zipData = this.cities[this.contractorLocationZip];
      if (!zipData) return (this.cityNames = []);

      this.mailingCityNames =
        typeof zipData.telepules === "string"
          ? [zipData.telepules]
          : Object.values(zipData.telepules);

      if (this.mailingCityNames.length === 1) {
        this.contractorSelectedLocationName = this.mailingCityNames[0];
      }
    },
    contractorBornDate: function(newVal) {
      this.$store.dispatch("verifyPage");
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-file-label::after {
  content: "Kiválasztás" !important;
}

.select2-selection__rendered {
  line-height: 38px !important;
}
.select2-container .select2-selection--single {
  height: 38px !important;
  border-color: #ced4da;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.select2-selection__arrow {
  height: 38px !important;
}

div.text-danger {
  color: #e4002b !important;
}
</style>
